import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';

const TycPage = () => {
  return (
    <div className="terms">
      <Header />
      <div className="container">
        <div>
          <h1>Noche de la Pizza y la Empanada 2026</h1>
          <p>
            Lea atentamente los Términos y Condiciones de uso. En caso de estar de acuerdo haga
            clic en <strong>“aceptar”.</strong>
          </p>

          <p>
            <strong>1)</strong> La Asociación de Pizzerías, Casas de Empanadas Asociación Civil (en adelante
            “APYCE”) pone a disposición de todo establecimiento dedicado a explotar un local comercial
            de venta de pizzas, casa de empanadas y afines dentro de la República Argentina (en
            adelante el “USUARIO”) una plataforma virtual (en adelante la “PLATAFORMA”) a efectos que
            estos últimos puedan utilizarla publicando sus productos y servicios vinculados a la
            actividad (en adelante “PyS”) con la intención de que sus clientes (en adelante los
            “CLIENTES”) conozcan las propuestas del USUARIO.
          </p>

          <p>
            <strong>2)</strong> APYCE pone a disposición del USUARIO la PLATAFORMA a efectos que este último
            participe de la llamada “Noche de la Pizza y la Empanada®” (en adelante el “EVENTO”), sin
            perjuicio que en el futuro pueda aplicarse el uso de la PLATAFORMA a otras necesidades y/o
            servicios.
          </p>

          <p>
            <strong>3)</strong> Para acceder al uso de la PLATAFORMA y participar del EVENTO el USUARIO deberá
            completar los datos requeridos. Podrán participar socios de APYCE y quienes no sean
            asociados participan con carácter de “invitado”, sin ningún tipo de costo (actual, ni futuro).
            La adhesión y permanencia resultan de carácter gratuito, pudiendo el USUARIO
            desuscribirse en la oportunidad que así lo requiriese.
          </p>

          <p>
            <strong>4)</strong> APYCE pone a disposición del USUARIO la PLATAFORMA para participar del EVENTO,
            la cual estará publicada durante los días previos, y hasta el <strong>11 de septiembre de 2026</strong>.
            El USUARIO acepta participar del EVENTO según esta reglamentación. Terminada la
            jornada dejará de publicarse el contenido del USUARIO. Sin perjuicio de ello APYCE podrá
            poner a disposición del USUARIO nuevamente la PLATAFORMA.
          </p>

          <p>
            <strong>5)</strong> APYCE solamente pone a disposición del USUARIO la PLATAFORMA, gratuita y de
            libre acceso, como una herramienta tecnológica para que éste introduzca los datos que
            vinculados a sus PyS, los que puedan ser conocidos por sus CLIENTES ingresando al
            siguiente enlace en internet:{' '}
            <a href="https://lanochedelapizzaylaempanada.com.ar/" target="_blank" rel="noreferrer">
              https://lanochedelapizzaylaempanada.com.ar/
            </a>{' '}
            o la que en el futuro se dispusiere.
          </p>

          <p><strong>6)</strong> Una vez aceptada la inscripción del USUARIO en el EVENTO, éste se compromete a:</p>
          <ol>
            <li>
              otorgar a sus clientes un beneficio del <strong>50% (cincuenta por ciento)</strong> de descuento
              respecto del precio habitual de lista al que venda sus productos el día anterior al EVENTO;
            </li>
            <li>
              ofrecer el beneficio mencionado en <strong>al menos tres PyS</strong> que comercialice
              habitualmente en su local dentro de la categoría “pizzas”, debiendo ser una de ellas la
              conocida como “muzzarella”. En la categoría “empanadas” el beneficio será de “3x2”
              (llevando tres PyS se abonan solo dos) debiendo al menos una “empanada de carne”;
            </li>
            <li>
              no está obligado a comercializar ambas categorías (“pizzas” y “empanadas”), pudiendo
              solo participar en una de ellas;
            </li>
            <li>
              podrá determinar a su libre criterio si la participación en el EVENTO aplica para la venta de
              “salón”, “delivery” o “take away” o solo alguno de ellas, <strong>no pudiendo modificar</strong> la
              elección luego de seleccionada;
            </li>
            <li>
              podrá determinar a su libre criterio si la participación en el EVENTO <strong>excluye algún
                sistema de cobro</strong>, no pudiendo modificar la elección luego de seleccionada;
            </li>
            <li>
              mantener el beneficio <strong>al menos el día del EVENTO entre las 20 y 24 hs</strong>.
            </li>
          </ol>

          <p>
            <strong>7)</strong> APYCE no es responsable por los contenidos que publique el USUARIO en la
            PLATAFORMA ni tiene control alguno sobre los mismos, siendo responsabilidad única de éste
            la veracidad de la información como el servicio que prestare a sus CLIENTES. El usuario,
            aceptando estos Términos y Condiciones, liberará a APYCE de cualquier reclamo
            proveniente de sus CLIENTES o terceros, incluyendo cualquier gasto, pago y/o accesoria
            que APYCE deba abonar por el USUARIO en relación al EVENTO. En caso de incumplimiento
            de las condiciones comerciales o de conducta contraria a estos Términos y Condiciones,
            APYCE podrá dar de baja inmediata al USUARIO de la PLATAFORMA y excluirlo de futuros
            eventos, sin derecho a reclamo alguno por parte de éste.
          </p>

          <p>
            <strong>8)</strong> Los CLIENTES no tienen vínculo alguno con APYCE sino con el USUARIO. APYCE no
            oferta, promociona ni vende PyS, como tampoco resulta intermediaria entre el USUARIO y el
            CLIENTE. Los CLIENTES sólo pueden conocer los PyS a través de la PLATAFORMA y deberán
            contactar al USUARIO en forma privada y habitual según los canales de atención que éste
            dispusiere.
          </p>

          <p>
            <strong>9)</strong> El USUARIO garantiza que no utilizará la PLATAFORMA a efectos de promocionar PyS
            para los que no se encuentra habilitado y/o en el comercio. Del mismo modo, el USUARIO
            garantiza que la promoción y/o venta que efectuare respecto de bebidas alcohólicas la
            realizará bajo su responsabilidad y liberará a APYCE de cualquier reclamo sobre dicha
            promoción y, sin perjuicio de ello, se compromete a indicar en toda publicación las frases
            “beber con moderación”, “prohibida su venta a menores de 18 años” de conformidad con lo
            dispuesto por el art. 5to. de la Ley 24.788 y/o la prevista por cualquier otra norma local,
            modificatoria u ampliatoria.
          </p>

          <p>
            <strong>10)</strong> El USUARIO presta su conformidad para que su nombre, logo, isologo y cualquier
            otra marca registrada de su propiedad sea exhibida a través de la PLATAFORMA únicamente
            para la difusión —por cualquier medio— del EVENTO y actividades promocionales
            institucionales relacionadas. Asimismo el USUARIO reconoce que no hará uso de la
            PLATAFORMA para publicar contenidos falsos, erróneos o sobre los cuales no posea los
            derechos, deslindando APYCE toda responsabilidad sobre los mismos en el USUARIO.
          </p>

          <p>
            <strong>11)</strong> APYCE no divulgará los datos aportados por el USUARIO a la PLATAFORMA y
            mantendrá la privacidad de los mismos conforme la legislación vigente en materia de
            protección de datos personales según ley 25.326.
          </p>

          <p>
            <strong>12)</strong> APYCE no es ni será responsable frente al USUARIO por la falta de disponibilidad de
            la plataforma de publicación o el sitio web durante las jornadas previstas en el punto b)
            anterior. En caso de fallas técnicas durante el EVENTO, el USUARIO mantendrá la obligación
            de otorgar los beneficios comprometidos a los CLIENTES que acrediten haber tomado
            conocimiento de la promoción por medios oficiales de APYCE.
          </p>

          <p>
            <strong>13)</strong> APYCE podrá modificar en cualquier momento los presentes Términos y Condiciones
            por razones operativas, legales o de fuerza mayor, notificando al USUARIO a través de la
            PLATAFORMA o por correo electrónico. La continuidad en el uso o la participación implicará
            aceptación de las modificaciones.
          </p>

          <p>
            <strong>14)</strong> Para toda controversia derivada de este acuerdo, las partes se someten a la
            jurisdicción de los tribunales ordinarios de la Ciudad Autónoma de Buenos Aires, con
            renuncia expresa a cualquier otro fuero o jurisdicción que pudiera corresponder.
          </p>

          <p>
            Haciendo clic en "Acepto los términos y condiciones 2026", el participante declara haber leído y comprendido los presentes términos y condiciones y se obliga conforme a ellos.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TycPage;
